import axios from 'axios';
import * as utils from '../../../utils/Utils';
import { getSelectedBrandId } from '../../../utils/ReduxUtils';
import {
  getGwApiRoot,
  getNonGwApiRoot,
  getApiRoot,
} from '../../../constants/ParamountReactConstants';
import { AsyncDispatch } from '../../../../types/global';
import { ApplicationState } from '../../../reducers';

const CancelToken = axios.CancelToken;
let fetchCancelToken: any;
let fetchValuesCanelToken: any;
let fetchUnitsCancelToken: any;

export function fetchAttributes(
  params: {
    page: number;
    limit: number;
    value_limit: number;
    parent_owner_brand_id: number;
    item_ids?: number[];
    filters?: string;
    scorecard_ids?: number[];
  },
  useGateway = false
) {
  if (fetchCancelToken) fetchCancelToken();

  const apiRoot = useGateway ? getGwApiRoot() : getNonGwApiRoot();

  return {
    meta: { page: params.page },
    type: 'FETCH_ATTRIBUTES',
    payload: axios.post(`${apiRoot}/part_attributes/ranks`, params, {
      cancelToken: new CancelToken(c => {
        fetchCancelToken = c;
      }),
    }),
  };
}

export function fetchValues({
  itemIds,
  attributeIds,
  filter,
  page = 1,
}: {
  itemIds: number[];
  attributeIds?: number[];
  filter?: string;
  page?: number;
}) {
  if (fetchValuesCanelToken) fetchValuesCanelToken();

  return (dispatch: AsyncDispatch, getState: () => ApplicationState) => {
    const brandId = getSelectedBrandId(getState());
    const requestData = {
      parent_owner_brand_id: brandId,
      item_ids: itemIds,
      part_attribute_ids: attributeIds,
      limit: utils.getPageLimit(),
      page,
      ...(filter && { filters: filter }),
    };
    return dispatch({
      meta: { page },
      type: 'FETCH_ATTRIBUTE_VALUES',
      payload: axios.post(`${getNonGwApiRoot()}/part_attributes/values/ranks`, requestData, {
        cancelToken: new CancelToken(c => {
          fetchValuesCanelToken = c;
        }),
      }),
    });
  };
}

export function fetchUnits({
  itemIds,
  attributeIds,
  filter,
  page = 1,
}: {
  itemIds: number[];
  attributeIds?: number[];
  filter?: string;
  page?: number;
}) {
  if (fetchUnitsCancelToken) fetchUnitsCancelToken();

  const requestData = {
    item_ids: itemIds,
    part_attribute_ids: attributeIds,
    limit: utils.getPageLimit(),
    page,
    ...(filter && { filters: filter }),
  };

  return {
    meta: { page },
    type: 'FETCH_ATTRIBUTE_UNITS',
    payload: axios.post(`${getNonGwApiRoot()}/part_attributes/meta_uoms/ranks`, requestData, {
      cancelToken: new CancelToken(c => {
        fetchUnitsCancelToken = c;
      }),
    }),
  };
}

export function fetchAttributesCount(item_ids: number[]) {
  return {
    type: 'FETCH_ATTRIBUTES_COUNT',
    payload: axios.post(`${getApiRoot()}/part_attributes/counts`, { item_ids }),
  };
}
